module.exports = __webpack_public_path__ + "Our-Working-Week-4.26b0fdf36c828d6edcdc.png";


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/assets/images/Our-Working-Week-4.png
// module id = ../../../../../src/assets/images/Our-Working-Week-4.png
// module chunks = main